export const environment = {
    production: false,
    URL: 'http://dev-flame.dev.dzi.bg',
    API_URL: '/api/v1/',
    BE_URL: 'http://dev-flame.dev.dzi.bg',
    FE_URL: 'http://dev-flame.dev.dzi.bg'
}
